// @ts-nocheck
import * as _112 from "./protobuf/any";
import * as _113 from "./protobuf/descriptor";
import * as _114 from "./protobuf/duration";
import * as _115 from "./protobuf/empty";
import * as _116 from "./protobuf/timestamp";
export namespace google {
  export const protobuf = {
    ..._112,
    ..._113,
    ..._114,
    ..._115,
    ..._116
  };
}